import React, { Component } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Input, Switch } from '@progress/kendo-react-inputs';
import { DateRangePicker } from '@progress/kendo-react-dateinputs';
import { getAuthToken, handleAuthTokenError, BASEURI, formatDate } from '../utils';
import loading from '../loading.svg';
import ConfirmDeleteDialog from '../general/ConfirmDeleteDialog';
import timezones from './timezones';
import XRangeChart from './XRangeChart';


class StationDetails extends Component {

    constructor(props) {
        super(props);

        this.state = {
            tab: null,
            message: '',
            addingChart: false,
            daterange: { start: new Date(new Date().setDate(new Date().getDate() - 30)), end: new Date() },
            range: 1,
            loading: false,
            updatingSensors: false,
            loadingForecastData: false,
            allGraphs: [],
            filteredGraphs: [],
            showConfirmDeleteDialog: false,
            generatingReports: false,
            deletingForecastReports: false,
            filteredTimezones: timezones,
        }

        this.changeDateRange = this.changeDateRange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.updateSensors = this.updateSensors.bind(this);
        this.getAllGraphs = this.getAllGraphs.bind(this);
        this.handleDropdownChange = this.handleDropdownChange.bind(this);
        this.itemRender = this.itemRender.bind(this);
        this.handleGraphFilterChange = this.handleGraphFilterChange.bind(this);
        this.downloadForecastData = this.downloadForecastData.bind(this);
        this.autoAddIrrigationChart = this.autoAddIrrigationChart.bind(this);
        this.generateReports = this.generateReports.bind(this);
        this.generateForecastReports = this.generateForecastReports.bind(this);
        this.deleteForecastReports = this.deleteForecastReports.bind(this);
        this.handleTimezoneFilterChange = this.handleTimezoneFilterChange.bind(this);
    }

    autoAddIrrigationChart() {

        if (!this.state.tab) {
            this.setState({ message: this.props.intl.formatMessage({ id: 'app.stations.viewStation.message', defaultMessage: 'Please select tab!' }) });
            return
        };

        this.setState({ addingChart: true });

        let url = `${BASEURI}/api/irrigation/auto-add-chart/`,
            options = {
                body: JSON.stringify(
                    {
                        device: this.props.serial,
                        tab: this.state.tab.id,
                    }
                ),
                method: 'POST',
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                }
            };
        getAuthToken()
            .then(token => token)
            .catch(handleAuthTokenError)
            .then(token => {

                //no token exists or all tokens are expired
                if (token === false) {
                    return false;

                }

                options.headers.Authorization = `Bearer  ${token}`;

                fetch(url, options)
                    .then((response) => {
                        if (!response.ok) {
                            response.text().then(err => console.log(err));
                            throw new Error(response.statusText, response.status);
                        }
                        return response.json();
                    })
                    .then((response) => {
                        this.setState({
                            addingChart: false,
                            message: response.message,
                        });
                    })
                    .catch(error => {
                        console.error('Error:', error);
                    });
            });

    }

    generateReports() {
        this.setState({ generatingReports: true });

        let url = `${BASEURI}/api/reports/generate-reports/${this.props.serial}`,
            options = {
                method: 'get',
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                }
            };
        getAuthToken()
            .then(token => token)
            .catch(handleAuthTokenError)
            .then(token => {

                //no token exists or all tokens are expired
                if (token === false) {
                    return false;

                }

                options.headers.Authorization = `Bearer  ${token}`;


                fetch(url, options)
                    .then((response) => {
                        if (!response.ok) {
                            response.text().then(err => console.log(err));
                            throw new Error(response.statusText, response.status);
                        }
                        return response.json();
                    })
                    .then((e) => {
                        this.setState({
                            generatingReports: false,
                        });
                    })
                    .catch(error => {
                        console.error('Error:', error);
                    });
            });
    }

    generateForecastReports() {
        this.setState({ generatingReports: true });

        let url = `${BASEURI}/api/reports/forecast/details/${this.props.serial}`,
            options = {
                method: 'get',
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                }
            };
        getAuthToken()
            .then(token => token)
            .catch(handleAuthTokenError)
            .then(token => {

                //no token exists or all tokens are expired
                if (token === false) {
                    return false;

                }

                options.headers.Authorization = `Bearer  ${token}`;


                fetch(url, options)
                    .then((response) => {
                        if (!response.ok) {
                            response.text().then(err => console.log(err));
                            throw new Error(response.statusText, response.status);
                        }
                        return response.json();
                    })
                    .then((e) => {
                        this.setState({
                            generatingReports: false,
                        });
                    })
                    .catch(error => {
                        console.error('Error:', error);
                    });
            });
    }

    deleteForecastReports() {
        this.setState({ deletingForecastReports: true });

        let url = `${BASEURI}/api/reports/forecast/details/${this.props.serial}`,
            options = {
                method: 'delete',
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                }
            };
        getAuthToken()
            .then(token => token)
            .catch(handleAuthTokenError)
            .then(token => {

                //no token exists or all tokens are expired
                if (token === false) {
                    return false;

                }

                options.headers.Authorization = `Bearer  ${token}`;


                fetch(url, options)
                    .then((response) => {
                        if (!response.ok) {
                            response.text().then(err => console.log(err));
                            throw new Error(response.statusText, response.status);
                        }
                        return response.json();
                    })
                    .then((e) => {
                        this.setState({
                            deletingForecastReports: false,
                        });
                    })
                    .catch(error => {
                        console.error('Error:', error);
                    });
            });
    }

    downloadForecastData(serial) {
        this.setState({ loadingForecastData: true });

        let url = `${BASEURI}/api/dashboard/stations/marker/download/`,
            options = {
                // station serial is provided instead of marker id
                // for that reason you must set station value 'true' 
                body: JSON.stringify({ 'station': serial }),
                method: 'POST',
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                }
            };
        getAuthToken()
            .then(token => token)
            .catch(handleAuthTokenError)
            .then(token => {

                //no token exists or all tokens are expired
                if (token === false) {
                    return false;

                }

                options.headers.Authorization = `Bearer  ${token}`;


                fetch(url, options)
                    .then((response) => {
                        if (!response.ok) {
                            response.text().then(err => console.log(err));
                            throw new Error(response.statusText, response.status);
                        }
                        return response.json();
                    })
                    .then((e) => {
                        this.setState({
                            loadingForecastData: false,
                        });
                    })
                    .catch(error => {
                        console.error('Error:', error);
                    });
            });

    }

    changeDateRange(range) {
        let daterange = {
            start: new Date(new Date().setMonth(new Date().getMonth() - range)),
            end: new Date()
        }
        this.setState({ range: range, daterange: daterange });
    }

    handleChange(event) {

        if (event.target.name === 'tab') {
            this.setState({ tab: event.target.value, message: '' });
        } else if (event.target.name === 'regionCode') {
            this.setState({ regionCode: event.target.value })
        }
        else {
            this.setState({ daterange: event.target.value });
        }


    }

    getAllGraphs() {
        let url = `${BASEURI}/api/allgraphs/`,
            options = {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                }
            };

        getAuthToken()
            .then(token => token)
            .catch(handleAuthTokenError)
            .then(token => {

                options.headers.Authorization = `Bearer  ${token}`;

                fetch(url, options)
                    .then((response) => {
                        return response.json();
                    })
                    .then((allGraphs) => {
                        this.setState({ allGraphs: allGraphs, filteredGraphs: allGraphs });
                    })
                    .catch(error => console.error('Error:', error));

            });

    }

    handleGraphFilterChange(event) {
        this.setState(() => {
            return {
                filteredGraphs: this.state.allGraphs.slice().filter(item => {
                    let filterText = event.filter.value,
                        itemText = `${item.label.toLowerCase()} ${item.chart.name.toLowerCase()} [${item.calculation.toLowerCase()}]`;

                    for (let i in filterText.split(' ')) {
                        let textSplit = filterText.split(' ')[i];
                        // if (item.name.toLowerCase().indexOf(textSplit) !== -1 || item.device.name.toLowerCase().indexOf(textSplit) !== -1 || item.port.indexOf(textSplit) !== -1)
                        if (itemText.indexOf(textSplit) !== -1)
                            return true
                        else
                            return false
                    }
                    return true;
                })
            };
        });
    }

    handleDropdownChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    componentDidMount() {
        this.getAllGraphs();
    }

    updateSensors() {

        this.setState({ updatingSensors: true });

        let url = `${BASEURI}/api/stations/sensors/${this.props.serial}/`,
            options = {
                method: 'PUT',
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                }
            };

        getAuthToken()
            .then(token => token)
            .catch(handleAuthTokenError)
            .then(token => {

                options.headers.Authorization = `Bearer  ${token}`;

                fetch(url, options)
                    .then((response) => {
                        return response.json();
                    })
                    .then(() => {
                        this.setState({
                            updatingSensors: false,
                        });
                    })
                    .catch(error => console.error('Error:', error));

            });
    }

    itemRender(li, itemProps) {
        const itemChildren = <div> {li.props.children} [{itemProps.dataItem.calculation}] <div style={{ color: "#00F" }}> {itemProps.dataItem.chart.name} </div> </div>;
        return React.cloneElement(li, li.props, itemChildren);
    }

    handleTimezoneFilterChange(e) {
        const value = e.filter.value.toLowerCase();
        const re = RegExp(value);
        this.setState({
            filteredTimezones: timezones.filter((item) => {
                return re.test(item.toLowerCase())
            })
        })
    }

    render() {
        const isRTL = this.props.intl?.locale?.startsWith('ar') ?? false;
        let selected = {
            border: '1px solid #1ce4b1'
        };
        let dialog = this.props.visible &&
            <Dialog dir={isRTL ? 'rtl' : 'ltr'} title={
                <span className="text-start">
                    <span className='block'>{this.props.name}</span>
                    {this.props.api === 'Neatmon' && <span className='text-sm text-gray-500 block'>FW:{this.props.details?.fw} | HW: {this.props.details?.hw}</span>}
                </span>}
                onClose={this.props.close}>

                <div className='modal-wrap station-dialog-ctn text-start'>
                    <fieldset>
                        <legend>
                            {this.props.intl.formatMessage({ id: 'app.stations.viewStation.stationDetail', defaultMessage: 'STATION DETAIL' })}
                        </legend>
                        <div className='mdl-grid'
                        // style={{marginLeft: '40px'}}
                        >
                            <div className='mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-col-phone'>
                                <Input
                                    required={false}
                                    name='name'
                                    label={this.props.intl.formatMessage({ id: 'app.stations.viewStation.name', defaultMessage: 'NAME' })}
                                    value={this.props.name}
                                    onChange={this.props.handleChange}
                                />
                            </div>
                            <div className='mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-col-phone'>
                                <Input
                                    required={false}
                                    name='plot'
                                    label={this.props.intl.formatMessage({ id: 'app.stations.viewStation.plot', defaultMessage: 'PLOT' })}
                                    value={this.props.plot}
                                    onChange={this.props.handleChange}
                                />
                            </div>
                            <div className='mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-col-phone'>
                                <Input
                                    required={false}
                                    name='crop'
                                    label={this.props.intl.formatMessage({ id: 'app.stations.viewStation.crop', defaultMessage: 'CROP' })}
                                    value={this.props.crop}
                                    onChange={this.props.handleChange}
                                />
                            </div>
                            <div className='mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-col-phone'>
                                <DropDownList
                                    required={false}
                                    data={this.state.filteredTimezones}
                                    name='timezone'
                                    label={this.props.intl.formatMessage({ id: 'app.stations.viewStation.timezone', defaultMessage: 'TIMEZONE' })}
                                    value={this.props.details?.timezone}
                                    onChange={this.props.handleChange}
                                    filterable={true}
                                    onFilterChange={this.handleTimezoneFilterChange}
                                />
                            </div>
                            <div className='mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-col-phone station-dialog-button'>
                                <button onClick={this.props.rename} className='k-button k-button-md k-button-solid k-button-solid-base k-rounded-md'>
                                    {this.props.renaming ?
                                        <img style={{ color: 'gray', width: '25px' }} src={loading} alt='loading'></img> :
                                        this.props.intl.formatMessage({ id: 'app.stations.viewStation.save', defaultMessage: 'Save' })}
                                </button>
                            </div>
                            {this.props.api === 'Dragino' &&
                                <div className='mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-col-phone station-dialog-button'>
                                    <button
                                        onClick={() => this.props.regenerateDraginoCredentials(this.props.serial)}
                                        disabled={this.props.regenerating}
                                        title={this.props.intl.formatMessage({ id: 'app.stations.dragino.regenerateHint', defaultMessage: 'Revokes the node\'s current certificate and shows a new setup sequence to paste into it' })}
                                        className='k-button k-button-md k-button-solid k-button-solid-base k-rounded-md'>
                                        {this.props.regenerating ?
                                            <img style={{ color: 'gray', width: '25px' }} src={loading} alt='loading'></img> :
                                            this.props.intl.formatMessage({ id: 'app.stations.dragino.regenerate', defaultMessage: 'Regenerate node credentials' })}
                                    </button>
                                </div>}
                        </div>
                    </fieldset>
                    <fieldset>
                        <legend>
                            {this.props.intl.formatMessage({ id: 'app.stations.viewStation.statonData', defaultMessage: 'STATION DATA' })}
                        </legend>
                        <XRangeChart
                            serial={this.props.serial}
                            data={this.props.data}
                            loading={this.props.details !== null && this.props.details.download_in_progress !== undefined ? this.props.details.download_in_progress : false}
                        />

                        {this.props.details !== null && this.props.details.download_in_progress !== undefined && this.props.details.download_in_progress ?
                            <div className="flex flex-wrap items-center gap-2 mt-2">
                                <span>{this.props.intl.formatMessage({ id: 'app.stations.viewStation.backgroundDownload', defaultMessage: 'Background download in progress' })}</span>
                                <img style={{ color: 'gray', width: '25px' }} src={loading} alt='loading'></img>
                            </div>
                            : null
                        }
                            <div>
                                <DateRangePicker
                                    calendarSettings={{ views: 1 }}
                                    value={this.state.daterange}
                                    onChange={this.handleChange}
                                // popupSettings = {this.popupSettings}
                                />
                                <div>
                                    <button
                                        onClick={() => this.changeDateRange(12)}
                                        className='k-button k-button-md k-button-solid k-button-solid-base k-rounded-md ag-range-btn'
                                        style={this.state.range === 12 ? selected : {}}>
                                        {this.props.intl.formatMessage({ id: 'app.stations.viewStation.1Y', defaultMessage: '1Y' })}
                                    </button>
                                    <button
                                        onClick={() => this.changeDateRange(6)}
                                        className='k-button k-button-md k-button-solid k-button-solid-base k-rounded-md ag-range-btn'
                                        style={this.state.range === 6 ? selected : {}}>
                                        {this.props.intl.formatMessage({ id: 'app.stations.viewStation.6M', defaultMessage: '6M' })}
                                    </button>
                                    <button
                                        onClick={() => this.changeDateRange(3)}
                                        className='k-button k-button-md k-button-solid k-button-solid-base k-rounded-md ag-range-btn'
                                        style={this.state.range === 3 ? selected : {}}>
                                        {this.props.intl.formatMessage({ id: 'app.stations.viewStation.3M', defaultMessage: '3M' })}
                                    </button>
                                    <button
                                        onClick={() => this.changeDateRange(1)}
                                        className='k-button k-button-md k-button-solid k-button-solid-base k-rounded-md ag-range-btn'
                                        style={this.state.range === 1 ? selected : {}}>
                                        {this.props.intl.formatMessage({ id: 'app.stations.viewStation.1M', defaultMessage: '1M' })}
                                    </button>
                                </div>
                                <div>
                                    <button
                                        className="k-button k-button-md k-button-solid k-button-solid-base k-rounded-md k-flat ag-range-btn"
                                        style={{ color: 'green', width: 'auto', minWidth: '200px' }}
                                        disabled={this.props.api === 'Neatmon'}
                                        onClick={() => this.props.download({
                                            range: {
                                                start: formatDate(this.state.daterange.start),
                                                end: formatDate(this.state.daterange.end)
                                            },
                                            device: this.props.serial
                                        })
                                        }>
                                        {this.props.downloading ?
                                            <img style={{ width: '20px' }} src={loading} alt='loading' /> :
                                            this.props.intl.formatMessage({ id: 'app.stations.viewStation.downloadStationData', defaultMessage: 'Download Station Data' })}
                                    </button>
                                </div>
                            </div>

                    </fieldset>
                    <fieldset>
                        <legend>
                            {this.props.intl.formatMessage({ id: 'app.stations.viewStation.irrigation', defaultMessage: 'IRRIGATION' })}
                        </legend>
                        <div className='mdl-grid'>
                            <div className='mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-col-phone'>
                                <DropDownList
                                    label={this.props.intl.formatMessage({ id: 'app.stations.viewStation.tab', defaultMessage: 'TAB' })}
                                    name='tab'
                                    dataItemKey='id'
                                    textField='name'
                                    data={this.props.tabs}
                                    onChange={this.handleChange}
                                />
                                <span className="block text-start" style={{ color: 'red', marginTop: '10px' }}>{this.state.message}</span>
                            </div>
                            <div className='mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-col-phone'>
                                <button
                                    title={this.props.intl.formatMessage({ id: 'app.stations.viewStation.autoAddIrrigation', defaultMessage: "Auto Add Irrigation Chart" })}
                                    className="k-button k-button-md k-button-solid k-button-solid-base k-rounded-md k-flat ag-range-btn"
                                    style={{ color: 'green', width: 'auto', minWidth: '200px' }}
                                    onClick={this.autoAddIrrigationChart}
                                >
                                    {this.state.addingChart ?
                                        <img style={{ width: '20px' }} src={loading} alt='loading' /> :
                                        this.props.intl.formatMessage({ id: 'app.stations.viewStation.autoAddIrrigation', defaultMessage: "Auto Add Irrigation Chart" })}
                                </button>

                            </div>
                        </div>
                    </fieldset>
                    {/* <fieldset>
              <legend>
                {this.props.intl.formatMessage({ id: 'app.stations.viewStation.reports', defaultMessage: 'WEATHER REPORTS' })}
              </legend>
              <div >
                <button
                  title={this.props.intl.formatMessage({ id: 'app.stations.viewStation.generateReports', defaultMessage: "Generate Reports" })}
                  className="k-button k-button-md k-button-solid k-button-solid-base k-rounded-md k-flat ag-range-btn"
                  style={{ color: 'green', width: 'auto', minWidth: '200px' }}
                  onClick={this.generateReports}
                >
                  {this.state.generatingReports ?
                    <img style={{ width: '20px' }} src={loading} alt='loading' /> :
                    this.props.intl.formatMessage({ id: 'app.stations.viewStation.generateReports', defaultMessage: "Generate Reports" })}
                </button>
              </div>
            </fieldset> */}

                    <fieldset>
                        <legend>
                            {this.props.intl.formatMessage({ id: 'app.stations.viewStation.weatherForecast', defaultMessage: 'WEATHER FORECAST' })}
                        </legend>
                        <div>
                            <div className="ag-switch-container flex flex-wrap items-center gap-5">
                                <span
                                    className="text-start min-w-0"
                                    title={this.props.intl.formatMessage({ id: 'app.stations.viewStation.mlForecast.title', defaultMessage: 'Use Station Data For Forecast' })}
                                >
                                    {this.props.intl.formatMessage({ id: 'app.stations.viewStation.mlForecast', defaultMessage: 'ML Forecast' })}
                                </span>
                                <Switch
                                    name='ml_forecast'
                                    checked={this.props.ml_forecast}
                                    onChange={this.props.handleStationDetailChange}
                                    disabled
                                />
                            </div>
                            <div className="text-start" style={{ marginTop: '10px', color: 'gray' }}>
                                {
                                    this.props.ml_forecast_remain_days
                                }
                            </div>
                            <div>
                                <div style={{ marginTop: '10px' }}>
                                    <button
                                        title={this.props.intl.formatMessage({ id: 'app.stations.viewStation.downloadForecastData', defaultMessage: 'Download Forecast Data' })}
                                        className="k-button k-button-md k-button-solid k-button-solid-base k-rounded-md k-flat ag-range-btn"
                                        style={{ color: 'green', width: 'auto', minWidth: '200px' }}
                                        onClick={() => { this.downloadForecastData(this.props.serial) }}>
                                        {this.state.loadingForecastData ? <img style={{ width: '20px' }} src={loading} alt='loading' /> : this.props.intl.formatMessage({ id: 'app.stations.viewStation.downloadForecastData', defaultMessage: 'Download Forecast Data' })}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="flex flex-col items-start gap-2 mt-2">
                            <button
                                title={this.props.intl.formatMessage({ id: 'app.stations.viewStation.generateForecastReports', defaultMessage: "Generate Forecast Reports" })}
                                className="k-button k-button-md k-button-solid k-button-solid-base k-rounded-md k-flat ag-range-btn"
                                style={{ color: 'green', width: 'auto', minWidth: '200px' }}
                                onClick={this.generateForecastReports}
                            >
                                {this.state.generatingReports ?
                                    <img style={{ width: '20px' }} src={loading} alt='loading' /> :
                                    this.props.intl.formatMessage({ id: 'app.stations.viewStation.generateForecastReports', defaultMessage: "Generate Forecast Reports" })}
                            </button>
                            <button
                                title={this.props.intl.formatMessage({ id: 'app.stations.viewStation.deleteForecastReports', defaultMessage: "Delete Forecast Reports" })}
                                className="k-button k-button-md k-button-solid k-button-solid-base k-rounded-md k-flat ag-range-btn delete"
                                style={{ width: 'auto', minWidth: '200px' }}
                                onClick={this.deleteForecastReports}
                            >
                                {this.state.deletingForecastReports ?
                                    <img style={{ width: '20px' }} src={loading} alt='loading' /> :
                                    this.props.intl.formatMessage({ id: 'app.stations.viewStation.deleteForecastReports', defaultMessage: "Delete Forecast Reports" })}
                            </button>
                        </div>

                    </fieldset>
                    <fieldset>
                        <legend>
                            {this.props.intl.formatMessage({ id: 'app.stations.viewStation.frostMonitoring', defaultMessage: 'FROST MONITORING' })}
                        </legend>
                        <div className="ag-switch-container flex flex-wrap items-center gap-5">
                            <span className="text-start min-w-0">
                                {this.props.intl.formatMessage({ id: 'app.stations.viewStation.frostmoni', defaultMessage: 'Frost Monitoring' })}
                            </span>
                            <Switch
                                name='frost_monitoring'
                                checked={this.props.frost_monitoring}
                                onChange={this.props.handleStationDetailChange}
                            // disabled={this.props.ml_forecast ? false : true}
                            />
                        </div>
                    </fieldset>
                    <fieldset>
                        <legend>
                            {this.props.intl.formatMessage({ id: 'app.stations.viewStation.well', defaultMessage: 'WELL' })}
                        </legend>
                        <div className="ag-switch-container flex flex-wrap items-center gap-5">
                            <span
                                className="text-start min-w-0"
                                title={this.props.intl.formatMessage({ id: 'app.stations.viewStation.wellDescription', defaultMessage: 'Activate to add chart for well' })}
                            >
                                {this.props.intl.formatMessage({ id: 'app.stations.viewStation.wellStation', defaultMessage: 'Well Station' })}
                            </span>
                            <Switch
                                name='is_well_station'
                                checked={this.props.is_well_station}
                                onChange={this.props.handleStationDetailChange}
                            />
                        </div>
                    </fieldset>
                    {this.state.showConfirmDeleteDialog && <ConfirmDeleteDialog
                        message={<p> <b>{this.props.name} [{this.props.serial}] </b>{this.props.intl.formatMessage({ id: 'app.chart.deleteChart.deleteMessage', defaultMessage: "will be deleted along with all of it's data. Type {delete} below to confirm." }, { delete: <span style={{ color: 'red' }}>DELETE</span> })}</p>}
                        onClose={() => this.setState({ showConfirmDeleteDialog: false })}
                        remove={() => {
                            this.props.removeStation(this.props.serial);
                            this.setState({ showConfirmDeleteDialog: false });
                        }}
                    />}
                </div>
                <DialogActionsBar>

                    <button className="k-button k-button-md k-button-solid k-button-solid-base k-rounded-md delete" onClick={() => { this.setState({ showConfirmDeleteDialog: true }) }}>{this.props.intl.formatMessage({ id: 'app.stations.viewStation.remove', defaultMessage: 'Remove' })}</button>
                    <button className="k-button k-button-md k-button-solid k-button-solid-base k-rounded-md" onClick={this.updateSensors}>
                        {this.state.updatingSensors ? <img style={{ color: 'gray', width: '25px' }} src={loading} alt='loading'></img> : this.props.intl.formatMessage({ id: 'app.stations.viewStation.updateSensor', defaultMessage: 'Update Sensors' })}
                    </button>
                    <button className="k-button k-button-md k-button-solid k-button-solid-base k-rounded-md" onClick={this.props.close}>{this.props.intl.formatMessage({ id: 'app.stations.viewStation.done', defaultMessage: 'Done' })}</button>
                </DialogActionsBar>
            </Dialog>;
        return (dialog);

    }
}


export default StationDetails;